import { clsx } from 'clsx';
import { isNil, upperFirst } from 'lodash-es';

import styles from '../../styles/element.module.scss';

export const colors = [
  'socialXBlack',
  'socialTiktokBlue',
  'socialTiktokRed',
  'socialTiktokWhite',
  'socialTiktokBlack',
  'socialInstagramPurple',
  'socialInstagramPink',
  'socialInstagramRed',
  'socialInstagramOrange',
  'socialInstagramYellow',
  'socialAndroidGreen',
  'socialAndroidBlack',
  'socialFacebookBlue',
  'socialGoogleGreen',
  'socialGoogleYellow',
  'socialGoogleRed',
  'socialGoogleBlue',
  'socialAppleGrey',
  'socialAppleBlack',
  'extendedVioletV7',
  'extendedVioletV6',
  'extendedVioletV5',
  'extendedVioletV4',
  'extendedVioletV3',
  'extendedVioletV2',
  'extendedVioletV1',
  'extendedVioletV05',
  'extendedVioletV00',
  'extendedNeutralN5',
  'extendedNeutralN45',
  'extendedNeutralN4',
  'extendedNeutralN3',
  'extendedNeutralN2',
  'extendedNeutralN1',
  'extendedNeutralN05',
  'extendedNeutralN00',
  'extendedOrangeO7',
  'extendedOrangeO5',
  'extendedOrangeO4',
  'extendedOrangeO2',
  'extendedOrangeO1',
  'extendedOrangeO05',
  'extendedOrangeO00',
  'extendedYellowY7',
  'extendedYellowY6',
  'extendedYellowY4',
  'extendedYellowY3',
  'extendedYellowY1',
  'extendedYellowY05',
  'extendedYellowY00',
  'extendedPinkP7',
  'extendedPinkP6',
  'extendedPinkP4',
  'extendedPinkP3',
  'extendedPinkP2',
  'extendedPinkP1',
  'extendedPinkP05',
  'extendedPinkP00',
  'extendedRedR7',
  'extendedRedR6',
  'extendedRedR5',
  'extendedRedR45',
  'extendedRedR4',
  'extendedRedR3',
  'extendedRedR2',
  'extendedRedR1',
  'extendedRedR05',
  'extendedRedR00',
  'extendedGreenG7',
  'extendedGreenG6',
  'extendedGreenG4',
  'extendedGreenG3',
  'extendedGreenG2',
  'extendedGreenG05',
  'extendedGreenG00',
  'extendedTealT7',
  'extendedTealT6',
  'extendedTealT5',
  'extendedTealT4',
  'extendedTealT3',
  'extendedTealT1',
  'extendedTealT05',
  'extendedTealT00',
  'extendedBlueB7',
  'extendedBlueB6',
  'extendedBlueB5',
  'extendedBlueB4',
  'extendedBlueB3',
  'extendedBlueB2',
  'extendedBlueB05',
  'extendedBlueB00',
  'achievementsBronze',
  'achievementsSilver',
  'achievementsGold',
  'secondaryT5',
  'secondaryY5',
  'secondaryP5',
  'secondaryO6',
  'secondaryG5',
  'secondaryY2',
  'secondaryG1',
  'secondaryT2',
  'secondaryB1',
  'expandedSand',
  'expandedNavy',
  'expandedMoss',
  'expandedMaroon',
  'expandedTeal',
  'expandedLemon',
  'coreWhite',
  'coreN7',
  'coreN6',
  'coreAsphalt',
  'coreO3',
  'extendedNeutralN7',
  'extendedNeutralN6',
  'extendedOrangeO6',
  'extendedOrangeO3',
  'extendedYellowY5',
  'extendedYellowY2',
  'extendedPinkP5',
  'extendedGreenG5',
  'extendedGreenG1',
  'extendedTealT2',
  'extendedBlueB1'
] as const;

export type Colors = (typeof colors)[number];

export interface ColorProps {
  color?: Colors;
  background?: Colors;
}

export const colorClassNames = (
  styles: Record<string, string>,
  propKey: 'color' | 'background',
  propValue: Colors | undefined
) => {
  const classNames: Record<string, boolean> = {};

  if (!isNil(propValue)) {
    classNames[
      styles[`${propKey}${upperFirst(propValue)}`] as keyof typeof classNames
    ] = true;
  }

  return classNames;
};

export const colorHelpers = {
  defaultProps: {
    color: undefined,
    background: undefined
  },
  classnames: (props: ColorProps): string => {
    return clsx({
      ...colorClassNames(styles, 'color', props.color),
      ...colorClassNames(styles, 'background', props.background)
    });
  },
  base: ({ color, background, ...props }: ColorProps & unknown) => props
};
